import CircularProgress from "@mui/material/CircularProgress";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Tab from "@mui/material/Tab";
import TextField from "@mui/material/TextField";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../../components/services/api";
import { DataGrid } from "@mui/x-data-grid";
import SearchData from "../components/SearchData";
import { styled } from "@mui/material/styles";
import FileUploadIcon from "@mui/icons-material/FileUpload";

export default function EditCustomer() {
  const history = useHistory();
  let { id } = useParams();
  const data_params = { id: id };
  const [value, setValue] = useState("1");
  const EmpId = localStorage.getItem("EmpId");
  const [mac5cod, setMAC5Code] = useState("");

  //Infomation UseState
  const [CustomerCode, setCustomerCode] = useState(0);
  const [AccountNo, setAccountNo] = useState("");
  const [Status, setStatus] = useState(1);
  const [CustomerName, setCustomerName] = useState("");
  const [CreditLimit, setCreditLimit] = useState("");
  const [CreditTerm, setCreditTerm] = useState("");
  const [Address, setAddress] = useState("");
  const [Telephone, setTelephone] = useState("");
  const [Fax, setFax] = useState("");
  const [ContractName, setContractName] = useState("");
  const [Email, setEmail] = useState("");
  const [Remark, setRemark] = useState("");
  const [Type, setType] = useState("");
  //Factory UseState
  const [Factory, setFactory] = useState();
  const [FoundStatus, setFoundStatus] = useState(false);
  //Add Factory UseState
  const [CreateFactoryName, setCreateFactoryName] = useState("");
  const [CreateFactoryAddress, setCreateFactoryAddress] = useState("");
  const [CreateFactoryPhone, setCreateFactoryPhone] = useState("");
  const [CreateFactoryFax, setCreateFactoryFax] = useState("");
  const [FactoryCreateData, setFactoryCreateData] = useState([]);
  const [dataFactory, setDataFactory] = useState([]);
  const [dataFactoryFilter, setDataFactoryFilter] = useState([]);
  const [checkboxSelection, setCheckboxSelection] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentFactoryData, setCurrentFactory] = useState([]);
  const [FactorySelectData, setFactorySelectData] = useState([]);
  const [updateFactory, setUpdateFactory] = useState(false);
  const [company, setCompany] = useState('');
  const [branch, setBranch] = useState('');
  const [companyData, setCompanyData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [companyDataFilter, setCompanyDataFilter] = useState([]);
  const [branchDataFilter, setBranchDataFilter] = useState([]);
  const [Factoryopen, setFactoryOpen] = useState(false);

  //fileupload
  const [FileData, setFileData] = useState([]);
  const [RemarkFile, setRemarkFile] = useState("");
  const [myFile, setMyFile] = useState([]);

  //const
  const [disableForm, setDisableForm] = useState(false);
  const [url, setUrl] = useState("");
  async function init() {
    const response = await fetch("/resources/config.json");
    const results = await response.json();
    setUrl(results);
  }
  const getDataCompanyList = async () => {
    try {
      const res = await api.get("api/master/company");
      setCompanyData(res.data.data.filter((e) => e.Status === true));
      setCompanyDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };
  const getDataBranchList = async () => {
    try {
      const res = await api.get("api/master/branch");
      // console.log(data);
      setBranchData(res.data.data.filter((e) => e.Status === true));
      setBranchDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    init()
    getDataCompanyList()
    getDataBranchList()
  }, [])

  const Input = styled("input")({
    display: "none",
  });

  /* table data */
  const columnsFactory = [
    { field: "FactoryName", headerName: "FACTORY NAME", width: 250 },
    { field: "FactoryAddress", headerName: "FACTORY ADDRESS", width: 250 },
    { field: "FactoryMobile", headerName: "FACTORY PHONE", width: 200 },
    {
      field: "Status",
      headerName: "STATUS",
      width: 100,
      valueFormatter: ({ value }) =>
        value === true ? "ACTIVE" : "INACTIVE",
    },
  ];

  //fetch Data
  const getDataFactoryList = async () => {
    try {
      const data = await api.get("api/factory/list");

      setDataFactory(data.data.filter((e) => e.Status === true));
      setDataFactoryFilter(data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };
  //fetch Data
  const getMyFile = async () => {
    const params = {
      id: id,
      uploadType: 1,
    };
    try {
      const data = await api.post("api/customer/file", params);
      setMyFile(data.data);
      // console.log(data);
    } catch (e) {
      console.log(e);
    }
  };
  const confirmAddFactory = () => {
    if (
      CreateFactoryName !== "" &&
      CreateFactoryAddress !== "" &&
      CreateFactoryPhone !== "" &&
      CreateFactoryFax !== ""
    ) {
      setOpen(false);
      const MySwal = withReactContent(Swal);
      MySwal.fire({
        title: "Confirm Save?",
        text: "I agree to save the data!",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes !",
      }).then((result) => {
        if (result.isConfirmed) {
          const data = {
            name: CreateFactoryName,
            address: CreateFactoryAddress,
            phone: CreateFactoryPhone,
            fax: CreateFactoryFax,
            status: 1,
            createId: EmpId,
          };
          setUpdateFactory(true)
          setFactoryCreateData([...FactoryCreateData, data]);
          setCreateFactoryName("");
          setCreateFactoryAddress("");
          setCreateFactoryPhone("");
          setCreateFactoryFax("");
        }
      });
    } else {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
    }
  };
  //Function
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickFactoryOpen = () => {
    setFactoryOpen(true);
  };
  const handleFactoryClose = () => {
    setFactoryOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleFileUpload = () => {
    let formData = new FormData();

    formData.append("fileUpload", FileData);
    formData.append("cusId", id);
    formData.append("uploadType", 1);

    formData.append("createId", EmpId);
    formData.append("remark", RemarkFile);



    api
      .post("api/customer/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "success",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire("สำเร็จ!", "เพิ่ม ไฟล์ สำเร็จ !", "success");
        });
        setFileData("");
        setRemarkFile("");
        getMyFile();

        // console.log(res);
      })
      .catch(() => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
          icon: "error",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire("ล้มเหลว!", "เพิ่ม ไฟล์ ไม่สำเร็จ !", "error");
        });
        setFileData("");
        setRemarkFile("");
        getMyFile();
      });
  };

  const getData = async () => {
    try {
      const data = await api
        .post("api/customer/detail/information", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            // console.log(response.data);
            response.data.map((res) => {
              setCustomerCode(res.code);
              setAccountNo(res.accountNo);
              setCustomerName(res.name);
              setCreditLimit(res.limit);
              setCreditTerm(res.term);
              setAddress(res.address);
              setTelephone(res.phone);
              setFax(res.fax);
              setContractName(res.contract);
              setEmail(res.email);
              setRemark(res.remark);
              setType(res.type);
              setStatus(res.status === true ? 1 : 0);
              setCompany(res?.company)
              setBranch(res?.branch)
              // res.status.data.map((res) => {
              //   setStatus(res);
              // });
              if (
                res?.factory[0]?.FactoryId !== null &&
                res?.factory[0]?.FactoryId !== "null"
              ) {
                setSelectedRows(res.factory);

              }
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/CustomerSupport/Customer");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (value === "1") {
      getData();
    }
    if (value === "2") {
      getDataFactoryList();
    }
    if (value === "3") {
      getMyFile();
    }
  }, [value]);

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          {Type == "1" ? "ตัวแทนขนส่งสินค้า" : null}
          {Type == "2" ? "ลูกค้า" : null}
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              {Type == "1" ? "Forwarder" : null}
              {Type == "2" ? "Customer" : null}
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">
              Customer Support / Customer
            </Typography>
            <Typography>
              <span>&nbsp;</span> / Detail {Type == "1" ? "Forwarder" : null}
              {Type == "2" ? "Customer" : null}
            </Typography>
          </Grid>
        </Grid>

        <TabContext value={value}>
          {Type == "2" ? (
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                variant="scrollable"
                scrollButtons="auto"
                onChange={handleChange}
                TabIndicatorProps={{
                  style: { backgroundColor: "transparent" },
                }}
              >
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Infomation"
                  value="1"
                />
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Factory"
                  value="2"
                />
                <Tab
                  sx={{
                    "&.Mui-selected": {
                      background: "#80C340",
                      color: "white",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    },
                  }}
                  label="Attach file"
                  value="3"
                />
              </TabList>
            </Box>
          ) : null}
          <TabPanel value="1">
            <Formik
              initialValues={{
                CustomerCode: "",
                CustomerName: "",
                Email: "",
                Address: "",
                ContractName: "",
                Telephone: "",
                Fax: "",
                Remark: "",
                Status: "",
                AccountNo: "",
                CreditLimit: "",
                CreditTerm: "",
                CompanyId:'',
                BranchId:''
              }}
              validate={(values) => {
                const errors = {};
                if (!CustomerCode || CustomerCode === "") {
                  errors.CustomerCode = "Required";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  // console.log(currentFactoryData);
                  const data = {
                    id: id,
                    code: CustomerCode,
                    name: CustomerName,
                    email: Email,
                    address: Address,
                    contract: ContractName,
                    phone: Telephone,
                    fax: Fax,
                    remark: Remark,
                    status: Status,
                    accountNo: AccountNo,
                    creditLimit: CreditLimit,
                    creditTerm: CreditTerm,
                    type: Type,
                    ModId: EmpId,
                    factory: currentFactoryData.length === 0 ? selectedRows : currentFactoryData,
                    newfactory: FactoryCreateData,
                    updateFactory: updateFactory,
                    CompanyId:company || null,
                    BranchId: branch || null

                  };
                  // console.log(data);

                  api
                    .post("api/customer/update", data)
                    .then((respose) => {
                      const MySwal = withReactContent(Swal);
                      MySwal.fire({
                        icon: "success",
                        didOpen: () => {
                          MySwal.clickConfirm();
                        },
                      }).then(() => {
                        return MySwal.fire(
                          "สำเร็จ!",
                          "แก้ไขข้อมูลส่วนตัวลูกค้าสำเร็จ !",
                          "success"
                        ).then((result) => {
                          if (result.isConfirmed) {
                            if (Type == "1") {
                              history.push("/CustomerSupport/Forwarder");
                            }
                            if (Type == "2") {
                              history.push("/CustomerSupport/Customer");
                            }
                          }
                        });
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                  // alert(JSON.stringify(data, null, 2));
                  setSubmitting(false);
                }, 400);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
                  <Grid container>
                    <Grid item xs={12} md={12}>
                      <div style={{ display: "flex" }}>
                        <TextField
                          name="customer_code"
                          label="Customer Code"
                          variant="outlined"
                          placeholder="Customer Code"
                          onChange={(e) => setCustomerCode(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={CustomerCode}
                        />
                        {errors.CustomerCode &&
                          touched.CustomerCode &&
                          errors.CustomerCode}
                        {/* <TextField
                          name="MAC-5-Code"
                          label="MAC-5 Code"
                          variant="outlined"
                          placeholder="MAC-5 Code"
                          onChange={(e) => setMAC5Code(e.target.value)}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          // classes={{ root: !mac5cod ? classes.customOutline : null }}
                          value={mac5cod}
                        // required
                        /> */}
                        <TextField
                          name="account_no"
                          label="MAC-5 Code"
                          variant="outlined"
                          placeholder="MAC-5 Code"
                          onChange={(e) => setAccountNo(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={AccountNo}
                        />
                        {errors.AccountNo &&
                          touched.AccountNo &&
                          errors.AccountNo}
                        <FormControl sx={{ width: "25%" }}>
                          <InputLabel id="select_status-label">
                            Status
                          </InputLabel>
                          <Select
                            name="select_status"
                            id="select_status"
                            value={Status}
                            label="Status"
                            onChange={(e) => setStatus(e.target.value)}
                          >
                            <MenuItem value={1}>Active</MenuItem>
                            <MenuItem value={0}>InActive</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="customer_name"
                          label="Customer Name"
                          variant="outlined"
                          placeholder="Customer Name"
                          onChange={(e) => setCustomerName(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={CustomerName}
                        />
                        {errors.CustomerName &&
                          touched.CustomerName &&
                          errors.CustomerName}

                        <TextField
                          name="credit_limit"
                          label="Credit limit"
                          variant="outlined"
                          type="number"
                          inputProps={{
                            maxLength: 13,
                            step: "0.1",
                            min: 1,
                          }}
                          placeholder="Credit limit"
                          onChange={(e) => setCreditLimit(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={CreditLimit}
                        />
                        {errors.CreditLimit &&
                          touched.CreditLimit &&
                          errors.CreditLimit}

                        <TextField
                          name="credit_term"
                          label="Credit Term (day)"
                          variant="outlined"
                          type="number"
                          inputProps={{
                            maxLength: 13,
                            min: 0,
                          }}
                          placeholder="Credit Term (day)"
                          onChange={(e) => setCreditTerm(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "25%" }}
                          InputLabelProps={{ shrink: true }}
                          value={CreditTerm}
                        />
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="address"
                          label="Address"
                          variant="outlined"
                          placeholder="Address"
                          onChange={(e) => setAddress(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={Address}
                        />
                        {errors.Address && touched.Address && errors.Address}
                        <TextField
                          name="telephone"
                          label="Telephone"
                          variant="outlined"
                          placeholder="Telephone"
                          onChange={(e) => setTelephone(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={Telephone}
                        />
                        {errors.Telephone &&
                          touched.Telephone &&
                          errors.Telephone}
                        <TextField
                          name="fax"
                          label="Fax"
                          variant="outlined"
                          placeholder="Fax"
                          onChange={(e) => setFax(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "25%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={Fax}
                        />
                        {errors.Fax && touched.Fax && errors.Fax}
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                        <TextField
                          name="contract_name"
                          label="Contract Name"
                          variant="outlined"
                          placeholder="Contract Name"
                          onChange={(e) => setContractName(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={ContractName}
                        />
                        {errors.ContractName &&
                          touched.ContractName &&
                          errors.ContractName}
                        <TextField
                          name="email"
                          label="Email"
                          variant="outlined"
                          placeholder="Email"
                          type="email"
                          onChange={(e) => setEmail(e.target.value)}
                          onBlur={handleBlur}
                          style={{ width: "50%", marginRight: 5 }}
                          InputLabelProps={{ shrink: true }}
                          value={Email}
                        />
                        {errors.Email && touched.Email && errors.Email}
                      </div>
                      <div style={{ display: "flex", marginTop: 10 }}>
                      <FormControl sx={{ width: "50%", marginRight: '5px'  }}>
                          <InputLabel>Company</InputLabel>
                          <Select
                            name="Company"
                            label="Company"
                            value={company}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                              setCompany(e.target.value)
                              setBranch('')
                              if(e.target.value){
                                setBranchDataFilter(branchData.filter((item) => item?.CompanyId === e.target.value))
                              } else {
                                setBranchDataFilter(branchData)
                              }
                            }}
                          >
                            <MenuItem value={''}>None</MenuItem>
                            {companyData?.map((item) => {
                              return (
                                <MenuItem value={item?.CompanyId}>{item?.CompanyName}</MenuItem>
                              )
                            })}
                            
                            </Select>
                        </FormControl>
                        <FormControl sx={{ width: "50%", marginRight: '5px'  }}>
                          <InputLabel>Branch</InputLabel>
                          <Select
                            name="Branch"
                            label="Branch"
                            value={branch}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => setBranch(e.target.value)}
                          >
                           <MenuItem value={''}>None</MenuItem>
                            {branchDataFilter?.map((item) => {
                              return (
                                <MenuItem value={item?.BranchId}>{item?.BranchName}</MenuItem>
                              )
                            })}
                          </Select>
                        </FormControl>

                     
                      </div>
                      <div style={{ marginTop: 10, marginBottom: 10 }}>
                        <TextField
                          fullWidth
                          rows={3}
                          multiline={true}
                          label="Remark *"
                          placeholder="Remark"
                          InputLabelProps={{ shrink: true }}
                          name="remark"
                          onChange={(e) => setRemark(e.target.value)}
                          onBlur={handleBlur}
                          value={Remark}
                        />
                        {errors.Remark && touched.Remark && errors.Remark}
                      </div>
                    </Grid>
                  </Grid>
                  <Button
                    type="button"
                    variant="outlined"
                    style={{
                      color: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    onClick={history.goBack}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginRight: "10px",
                    }}
                    disabled={isSubmitting}
                  >
                    {isSubmitting && <CircularProgress size={22} />}
                    {!isSubmitting && "SAVE"}
                  </Button>
                </form>
              )}
            </Formik>
          </TabPanel>
          <TabPanel value="2">
            <div style={{ display: "flex", float: "right" }}>
              <Button
                style={{
                  backgroundColor: "#80C340",
                  color: "white",
                  textTransform: "none",
                }}
                onClick={handleClickOpen}
              >
                <span className="material-icons-outlined">add</span>
                เพิ่มโรงงานใหม่
              </Button>
            </div>
            <div style={{ display: "flex", float: "right", marginRight: 5 }}>
              <Button
                style={{
                  backgroundColor: "#80C340",
                  color: "white",
                  textTransform: "none",
                }}
                onClick={handleClickFactoryOpen}
              >
                <span className="material-icons-outlined">add</span>
                เลือกโรงงานในระบบ
              </Button>
            </div>

            <div>
              {selectedRows?.length > 0 ? (
                <div>
                  <h6
                    style={{ marginTop: "10px" }}
                    className="textcolordarkblue"
                  >
                    {" "}
                    โรงงานของคุณ
                  </h6>
                  <TableContainer
                    sx={{
                      marginTop: 5,
                      marginBottom: 2,
                      maxHeight: "50vh",
                      overflow: "auto",
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="10%">
                            #
                          </TableCell>
                          <TableCell align="center" width="25%">ชื่อโรงงาน</TableCell>
                          <TableCell align="center" width="25%">
                            ที่อยู่โรงงาน
                          </TableCell>
                          <TableCell align="center" width="15%">
                            เบอร์โทรศัพท์
                          </TableCell>
                          <TableCell align="center" width="15%">
                            แฟ็กซ์
                          </TableCell>
                          <TableCell align="center" width="10"> </TableCell>
                        </TableRow>
                      </TableHead>
                      {selectedRows?.map((data, index) => {
                        return (
                          <TableBody key={index}>
                            <TableCell align="center" >{index + 1}</TableCell>
                            <TableCell align="left"  >
                              {data.FactoryName}
                            </TableCell>
                            <TableCell align="left" >
                              {data.FactoryAddress}
                            </TableCell>
                            <TableCell align="left">
                              {data.FactoryMobile}
                            </TableCell>
                            <TableCell align="left">
                              {data.FactoryFax}
                            </TableCell>
                            <TableCell align="center">
                              <Button
                                variant="outlined"
                                style={{
                                  color: "#FF0000",
                                  borderColor: "#FF0000",
                                }}
                                onClick={() => {
                                  const newsplit = selectedRows.splice(
                                    index,
                                    1
                                  );
                                  const varinew = selectedRows.map((x) => {
                                    const newData = {
                                      facId: x.FactoryId,
                                      createId: EmpId,
                                    };
                                    return newData;
                                  });
                                  setSelectedRows([...selectedRows]);
                                  setCurrentFactory(varinew);
                                  setUpdateFactory(true)
                                }}
                              >
                                ลบ
                              </Button>
                            </TableCell>
                          </TableBody>
                        );
                      })}
                    </Table>
                  </TableContainer>
                </div>
              ) : null}

              <div>
                {FactoryCreateData?.length > 0 ? (
                  <div>
                    <h6
                      style={{ marginTop: "10px" }}
                      className="textcolordarkblue"
                    >
                      {" "}
                      โรงงานสร้างขึ้นใหม่
                    </h6>
                    <TableContainer
                      sx={{
                        marginTop: 2,
                        marginBottom: 2,
                        maxHeight: "50vh",
                        overflow: "auto",
                      }}
                    >
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" width="5%">
                              #
                            </TableCell>
                            <TableCell align="center">ชื่อโรงงาน</TableCell>
                            <TableCell align="center" width="50%">
                              ที่อยู่โรงงาน
                            </TableCell>
                            <TableCell align="center" width="50%">
                              เบอร์โทรศัพท์
                            </TableCell>
                            <TableCell align="center" width="50%">
                              แฟ็กซ์
                            </TableCell>
                            <TableCell align="center"> </TableCell>
                          </TableRow>
                        </TableHead>
                        {FactoryCreateData?.map((data, index) => {
                          return (
                            <TableBody key={index}>
                              <TableCell align="center">{index + 1}</TableCell>
                              <TableCell align="center">{data.name}</TableCell>
                              <TableCell align="left" width="50%">
                                {data.address}
                              </TableCell>
                              <TableCell align="left" width="50%">
                                {data.phone}
                              </TableCell>
                              <TableCell align="left" width="50%">
                                {data.fax}
                              </TableCell>
                              <TableCell align="center">
                                <Button
                                  variant="outlined"
                                  style={{
                                    color: "#FF0000",
                                    borderColor: "#FF0000",
                                  }}
                                  onClick={() => {
                                    FactoryCreateData.splice(index, 1);
                                    setFactoryCreateData([
                                      ...FactoryCreateData,
                                    ]);
                                    setUpdateFactory(true)
                                  }}
                                >
                                  ลบ
                                </Button>
                              </TableCell>
                            </TableBody>
                          );
                        })}
                      </Table>
                    </TableContainer>
                  </div>
                ) : null}
              </div>
            </div>
          </TabPanel>
          <TabPanel value="3">
            <h5 style={{ marginTop: "10px" }} className="textcolordarkblue">
              อัพโหลดสำเนาเอกสาร
            </h5>
            <br />
            <label>(ไฟล์ที่ยอมรับ .pdf, .doc , .xls, .txt, .jpeg, .png )</label>
            <div style={{ marginTop: 10 }}>
              <label htmlFor="contained-button-file">
                <Input
                  accept="application/doc,application/pdf,application/vnd.ms-excel, image/png, image/jpeg, .txt"
                  id="contained-button-file"
                  multiple
                  type="file"
                  onChange={(e) => {
                    if (e.target.files[0].length !== 0) {
                      setFileData(e.target.files[0]);
                    } else {
                      const MySwal = withReactContent(Swal);

                      MySwal.fire(
                        "กรุณาตรวจสอบไฟล์!",
                        "กรุณาเลือกไฟล์อัพโหลด .PDF .DOC .XLS เท่านั้น !",
                        "info"
                      );
                    }
                    // console.log(e.target.files[0]);
                  }}
                />
                <Button variant="contained" color="primary" component="span">
                  {/* {console.log(FileData.name)} */}

                  {FileData?.name != undefined
                    ? FileData?.name
                    : "เลือกเอกสารที่ต้องการอัพโหลด"}
                </Button>
              </label>
            </div>
            <div style={{ display: "flex", marginTop: 10 }}>
              {FileData?.name != undefined ? (
                <TextField
                  name="remarkFile"
                  label="Remark *"
                  variant="outlined"
                  placeholder="Remark *"
                  onChange={(e) => setRemarkFile(e.target.value)}
                  style={{ width: "100%", marginRight: 5 }}
                  InputLabelProps={{ shrink: true }}
                  value={RemarkFile}
                />
              ) : null}
              <Button
                variant="contained"
                style={{ marginLeft: "10px" }}
                color="success"
                component="span"
                onClick={handleFileUpload}
              >
                <FileUploadIcon /> Upload
              </Button>
            </div>
            <div>
              {myFile?.length > 0 ? (
                <div>
                  <h6
                    style={{ marginTop: "10px" }}
                    className="textcolordarkblue"
                  >
                    {" "}
                    ไฟล์ของคุณ
                  </h6>
                  <TableContainer
                    sx={{
                      marginTop: 2,
                      marginBottom: 2,
                      maxHeight: "50vh",
                      overflow: "auto",
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center" width="5%">
                            #
                          </TableCell>
                          <TableCell align="center">ชื่อไฟล์</TableCell>
                          <TableCell align="center" width="50%">
                            ลบ
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {myFile?.map((data, index) => {
                        return (
                          <TableBody key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">
                              {data.remark}
                              <br />
                              <a
                                href={

                                  url.REACT_APP_BASE_API + data.path
                                }
                                target="_blank"
                              >
                                <font color="grey">{data.name}</font>
                              </a>
                            </TableCell>

                            <TableCell align="center">
                              <Button
                                variant="contained"
                                style={{
                                  color: "white",
                                  backgroundColor: "#FF0000",
                                }}
                                onClick={async () => {
                                  const MySwal = withReactContent(Swal);
                                  MySwal.fire({
                                    title: "คุณกำลังลบไฟล์?",
                                    text: "คุณกำลังต้องการที่จะลบไฟล์ใช่หรือไม่!",
                                    icon: "info",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "ใช่ !",
                                    cancelButtonText: "ไม่",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      const params = {
                                        id: data.id,
                                      };
                                      api
                                        .post(
                                          "api/customer/file/delete",
                                          params
                                        )
                                        .then((respose) => {
                                          const MySwal = withReactContent(Swal);

                                          MySwal.fire({
                                            icon: "success",
                                            didOpen: () => {
                                              MySwal.clickConfirm();
                                            },
                                          }).then(() => {
                                            return MySwal.fire(
                                              "สำเร็จ!",
                                              "ลบไฟล์สำเร็จ !",
                                              "success"
                                            );
                                          });
                                          getMyFile();
                                        });
                                    }
                                  });
                                }}
                              >
                                ลบ
                              </Button>
                            </TableCell>
                          </TableBody>
                        );
                      })}
                    </Table>
                  </TableContainer>
                </div>
              ) : null}
            </div>
          </TabPanel>
        </TabContext>
      </Card>
      {/* Modal Add */}

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>เพิ่มโรงงาน</DialogTitle>
        <DialogContent>
          <DialogContentText>
            กรุณากรอกข้อมูลให้ครบถ้วนและตรวจสอบก่อน ตกลง .
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="create_fac_name"
            label="ชื่อโรงงาน"
            onChange={(e) => setCreateFactoryName(e.target.value)}
            value={CreateFactoryName}
            fullWidth
            variant="standard"
          />
          <TextField
            margin="dense"
            id="create_fac_addr"
            label="ที่อยู่โรงงาน"
            fullWidth
            variant="standard"
            onChange={(e) => setCreateFactoryAddress(e.target.value)}
            value={CreateFactoryAddress}
          />

          <TextField
            margin="dense"
            id="Telephone"
            label="เบอร์โทรศัพท์"
            type="tel"
            fullWidth
            variant="standard"
            onChange={(e) => setCreateFactoryPhone(e.target.value)}
            value={CreateFactoryPhone}
          />
          <TextField
            margin="dense"
            id="Fax"
            label="แฟ็กซ์"
            type="tel"
            fullWidth
            variant="standard"
            onChange={(e) => setCreateFactoryFax(e.target.value)}
            value={CreateFactoryFax}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={confirmAddFactory}>Confirm</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Factoryopen}
        onClose={handleFactoryClose}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Add Factory</DialogTitle>
        <DialogContent style={{ minHeight: "600px" }}>
          <DialogContentText>
            Please complete the information. and check before confirming .
          </DialogContentText>
          <SearchData name={dataFactory} onsetData={setDataFactoryFilter} />
          <DataGrid
            getRowId={(r) => r.FactoryId}
            pageSize={10}
            rowsPerPageOptions={[10]}
            rows={dataFactoryFilter}
            columns={columnsFactory}
            autoHeight
            checkboxSelection={checkboxSelection}
            selectionModel={selectedRows.map((x) => x.FactoryId)}
            {...dataFactoryFilter}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = dataFactoryFilter.filter((row) =>
                selectedIDs.has(row.FactoryId)
              );
              setSelectedRows(selectedRows);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFactoryClose}>Cancel</Button>
          <Button
            onClick={() => {
              const vari = selectedRows.map((x) => {
                const newData = {
                  facId: x.FactoryId,
                  createId: EmpId,
                };
                return newData;
              });
              setUpdateFactory(true)
              // setSelectedRows(vari);

              setCurrentFactory(vari);
              setFactoryOpen(false);
              // console.log(selectedRows);
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
